/**
 * Created by parthm on 05/04/16.
 */
export class CreditCardValidationService {
  constructor() {
    this.verCC = null;
    this.verCVC = null;
    this.verEXP = null;
    this.defaultFormat = /(\d{1,4})/g;
    this.defaultRegexFormat = /(\w{1,4})/g;
    //All regex as per ngPayment module from https://github.com/raaspazasu/ngPayments
    this.cards = [
      {
        type: 'visa',
        icon: 'visa',
        pattern: /^4/,
        format: this.defaultFormat,
        regexFormat: this.defaultRegexFormat,
        length: [13, 14, 15, 16],
        cvcLength: [3],
        maxCardLength: 19,
        maxCvvLength: 3,
        luhn: true
      },
      {
        type: 'rupay',
        icon: 'rupay',
        pattern: /(^508[5-9][0-9][0-9]|60698[5-9]|60699[0-9]|607[0-8][0-9][0-9]|6079[0-7][0-9]|60798[0-4]|(?!608000)608[0-4][0-9][0-9]|608500|6521[5-9][0-9]|652[2-9][0-9][0-9]|6530[0-9][0-9]|6531[0-4][0-9])/,
        format: this.defaultFormat,
        regexFormat: this.defaultRegexFormat,
        length: [16],
        cvcLength: [3],
        maxCardLength: 19,
        maxCvvLength: 3,
        luhn: true
        //=============Regex for RUPAY as per PayU
      },
      {
        type: 'laser',
        icon: 'common-card',
        pattern: /^(6706|6771|6709)/,
        format: this.defaultFormat,
        regexFormat: this.defaultRegexFormat,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        maxCardLength: 23,
        maxCvvLength: 3,
        luhn: true
      },
      {
        type: 'maestro',
        icon: 'maestro',
        pattern: /(^(5[06-8]|6\d)\d{14}(\d{2,3})?[\d]+)|(^(5[06-8]|6\d)[\d]+)|(^((504([435|645|774|775|809|993]))|(60([0206]|[3845]))|(622[018])\d)[\d]+)/,
        format: this.defaultFormat,
        regexFormat: this.defaultRegexFormat,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        maxCardLength: 23,
        maxCvvLength: 3,
        cvcLength: [3],
        luhn: true
        //=============Regex for MAESTRO as per PayU but updated to be startsWith
      },
      {
        type: 'mastercard',
        icon: 'mastercard',
        pattern: /^5[1-5]/,
        format: this.defaultFormat,
        regexFormat: this.defaultRegexFormat,
        length: [16],
        cvcLength: [3],
        maxCardLength: 19,
        maxCvvLength: 3,
        luhn: true
      },
      {
        type: 'amex',
        icon: 'amex',
        pattern: /^3[47]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        regexFormat: /(\w{1,4})(\w{1,6})?(\w{1,5})?/,
        length: [15],
        cvcLength: [3, 4],
        maxCardLength: 17,
        maxCvvLength: 4,
        luhn: true
      },
      {
        type: 'diners',
        icon: 'diners',
        pattern: /^(36|38|30[0-5])/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
        regexFormat: /(\w{1,4})(\w{1,6})?(\w{1,4})?/,
        length: [14],
        cvcLength: [3],
        maxCardLength: 16,
        maxCvvLength: 3,
        luhn: true
      },
      {
        type: 'jcb',
        icon: 'common-card',
        pattern: /^35/,
        format: this.defaultFormat,
        regexFormat: this.defaultRegexFormat,
        length: [16],
        cvcLength: [3],
        maxCardLength: 19,
        maxCvvLength: 3,
        luhn: true
      }
    ];
  }

  verified() {
    return this.verCC && this.verCVC && this.verEXP;
  }

  reFormatCardNumber(num, cardFromNo = null) {
    var card, groups, upperLength, _ref;
    card = cardFromNo || this.cardFromNumber(num);
    if (!card) {
      return num;
    }
    upperLength = card?.length[card?.length.length - 1];
    num = num.replace(/\D/g, '');
    num = num.slice(0, +upperLength + 1 || 9e9);
    if (card.format.global) {
      return (_ref = num.match(card.format)) != null ? _ref.join(' ') : void 0;
    } else {
      groups = card.format.exec(num);
      if (groups != null) {
        groups.shift();
      }
      return groups != null ? groups.join(' ') : void 0;
    }
  } //reFormatCardNumber

  cardFromNumber(num) {
    var card, _i, _len;
    num = (num + '').replace(/\D/g, '');
    for (_i = 0, _len = this.cards.length; _i < _len; _i++) {
      card = this.cards[_i];
      if (card.pattern.test(num)) {
        return card;
      }
    }
  } //cardFromNumber

  luhnCheck(num) {
    var digit, digits, odd, sum, _i, _len, card, length;
    odd = true;
    sum = 0;
    card = this.cardFromNumber(num);
    if (!card) {
      return false;
    }
    length = card.length[card.length.length - 1];
    digits = (num + '').split('').reverse();
    for (_i = 0, _len = digits?.length; _i < _len; _i++) {
      digit = digits[_i];
      digit = parseInt(digit, 10);
      if ((odd = !odd)) {
        digit *= 2;
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    return (this.verCC = sum % 10 === 0);
  } //luhnCheck

  validateCardExpiry(month, year) {
    var currentTime, expiry, prefix, _ref;
    if (typeof month === typeof {} && 'month' in month) {
      _ref = month;
      month = _ref.month;
      year = _ref.year;
    }
    if (!(month && year)) {
      return false;
    }
    if (!/^\d+$/.test(month)) {
      return false;
    }
    if (!/^\d+$/.test(year)) {
      return false;
    }
    if (!(parseInt(month, 10) <= 12)) {
      return false;
    }
    if (year?.length === 2) {
      prefix = new Date().getFullYear();
      prefix = prefix.toString().slice(0, 2);
      year = prefix + year;
    }
    expiry = new Date(year, month);
    currentTime = new Date();
    expiry.setMonth(expiry.getMonth() - 1);
    expiry.setMonth(expiry.getMonth() + 1, 1);
    return (this.verEXP = expiry > currentTime);
  } //validateCardExpiry

  validateCVC(a, b) {
    return (this.verCVC = a.indexOf(b) > -1);
  }

  getRegexForCard(cardBrand) {
    var card = this.cards.find({ type: cardBrand });
    return card ? card.regexFormat : this.defaultRegexFormat;
  }

  isValidCardNo(cardNo) {
    const trimmedCardNo = cardNo.toString().replace(/ |-/g, '');
    return this.luhnCheck(trimmedCardNo);
  }

  getCardFromBrand(brand) {
    // brand = visa/mastercard/maestro/rupay
    return this.cards.find(c => c.type.toLowerCase() === brand.toLowerCase());
  }

  getBinAndLast4(cardNo) {
    const simpleNo = cardNo.replace(/\D/g, '');
    return {
      last4: simpleNo.substr(-4),
      bin: simpleNo.substr(0, 6),
    };
  }
}
